import { gql } from "@apollo/client";

export default gql`
  mutation CreateGroup($group: GroupInput!) {
    createGroup(group: $group) {
      _id
      slug
    }
  }
`;
